import React from 'react'
import moment from 'moment'

import { Div, H5 } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

const AddedEvent = ({event, name}) => {
  return (
    <Div className="contact-event--container">
      <Div className="contact-event--icon">
        <Icon name="user-add" width={20} height={20}/>
      </Div>
      <Div className="contact-event--event-description">
        <H5>
          {name} was added to Drift
        </H5>
        <span>{moment(event.createdAt).format('MM/DD/YYYY hh:mm A')}</span>
      </Div>
    </Div>
  )
}

export default AddedEvent
